'use strict';

var _ = require('lodash');
var MappedBookingsDataRetrieverServices = function MappedBookingsDataRetrieverServices(dataRetrieverService, dataRetrieverConstantsService, SearchCriteriaRule, $q) {
  var tripIdTemplate = _.template('<%= marketingCarrier %><%=marketingFlightNumber %> <%=segmentationOrigin %>-<%=segmentationDestination %>');
  var availableMappedModes = {
    'market-product-group': getMarketProductServicesData,
    'market': getMarketServicesData,
    'service': getServiceData,
    'service-management': getServiceManagementData
  };
  function getData(mode, screen, entities, entityData) {
    var selectedMappedMode = _.get(availableMappedModes, mode, _.noop);
    return selectedMappedMode(screen, entities, entityData);
  }
  function getServiceData(screen, currentMappedBookings, mappedBookingData) {
    return $q.when(transformMappedBookings(_.filter(currentMappedBookings, ['serviceId', mappedBookingData.serviceId]))).then(_.partialRight(sort, ['bookings', 'className'], ['desc', 'asc']));
  }
  function getMarketProductServicesData(screen, currentMappedBookings, mappedBookingData) {
    var filterGroups = _.map(currentMappedBookings, 'classGroup');
    return dataRetrieverService.getDataRetriever(dataRetrieverConstantsService[screen], 'market-product-group-mapped-bookings', null).retrieveData('market-product-group-mapped-bookings', preparefilters(mappedBookingData)).then(_.partialRight(filterMarketProductServices, filterGroups)).then(_.partialRight(sort, ['tripBookings', 'classGroup'], ['desc', 'asc'])).then(clean);
  }
  function getServiceManagementData(screen, currentMappedBookings, mappedBookingData) {
    return $q.when(transformMappedBookings([mappedBookingData])).then(_.partialRight(sort, ['bookings'], ['desc']));
  }
  function clean(marketProductTrippingBookings) {
    return _.map(marketProductTrippingBookings, function (marketProductTrippingBooking) {
      return _.pick(marketProductTrippingBooking, 'classGroup', 'market', 'tripBookings');
    });
  }
  function filterMarketProductServices(marketProductTrippingBookings, filterGroups) {
    return _.filter(marketProductTrippingBookings, function (marketProductTrippingBooking) {
      return _.indexOf(filterGroups, marketProductTrippingBooking.classGroup) > -1;
    });
  }
  function getMarketServicesData(screen, currentMappedBookings, mappedBookingData) {
    return dataRetrieverService.getDataRetriever(dataRetrieverConstantsService[screen], 'market-mapped-bookings', null).retrieveData('market-mapped-bookings', preparefilters(mappedBookingData)).then(_.partialRight(sort, ['tripBookings'], ['desc']));
  }
  function preparefilters(mappedBookingSelected) {
    return [new SearchCriteriaRule({
      operator: 'Between',
      leftOperand: mappedBookingSelected.departureDateMoment.clone().startOf('day'),
      field: 'departureDate',
      rightOperand: mappedBookingSelected.departureDateMoment.clone().endOf('day')
    }), new SearchCriteriaRule({
      operator: '=',
      leftOperand: getOrigin(mappedBookingSelected),
      field: 'origin'
    }), new SearchCriteriaRule({
      operator: '=',
      leftOperand: getDestination(mappedBookingSelected),
      field: 'destination'
    })];
  }
  function getOrigin(mappedBookingSelected) {
    if (mappedBookingSelected.origin) {
      return mappedBookingSelected.origin;
    } else if (mappedBookingSelected.market) {
      return mappedBookingSelected.market.split('-')[0];
    }
  }
  function getDestination(mappedBookingSelected) {
    if (mappedBookingSelected.destination) {
      return mappedBookingSelected.destination;
    } else if (mappedBookingSelected.market) {
      return mappedBookingSelected.market.split('-')[1];
    }
  }
  function transformMappedBookings(mappedBookings) {
    return _.reduce(mappedBookings, function (result, mappedBookingData) {
      return _.concat(result, transformTripId(mappedBookingData.mappedTripBooking || mappedBookingData.mappedTripBookings, mappedBookingData.className));
    }, []);
  }
  function transformTripId(mappedTripBookings, className) {
    return _.chain(mappedTripBookings).filter(function (mappedTripBooking) {
      return !_.isUndefined(mappedTripBooking.total);
    }).map(function (mappedTripBooking) {
      var service = _(mappedTripBooking.tripId).split('|').map(function (tripId) {
        return tripIdTemplate(destructuringTripId(tripId));
      }).join(',');
      return {
        service: service,
        bookings: mappedTripBooking.total || 0,
        className: className
      };
    }).groupBy('service').map(function (array, service) {
      return {
        service: service,
        bookings: _.sum(_.map(array, 'bookings')),
        className: className
      };
    }).value();
  }
  function destructuringTripId(tripId) {
    var keyPosition = ['segmentationOrigin', 'departureDate', 'operatingCarrier', 'marketingCarrier', 'operatingFlightNumber', 'marketingFlightNumber', 'segmentationDestination', 'marketingBookingClass', 'operatingFlightNumberSuffix', 'marketingFlightNumberSuffix'];
    return _(tripId).split('.').map(function (value, index) {
      return [keyPosition[index], value];
    }).fromPairs().value();
  }
  function sort(data, fields, fieldSort) {
    return _.orderBy(data, fields, fieldSort);
  }
  return {
    getData: getData
  };
};
MappedBookingsDataRetrieverServices.$inject = ['DataRetrieverService', 'DataRetrieverConstantsService', 'SearchCriteriaRuleFactory', '$q'];
module.exports = MappedBookingsDataRetrieverServices;